import styled, { css } from "styled-components";
import { media } from "src/styles/mixins";

export const TableWrapper = styled.div`
  padding: 0 16px;
  grid-area: table;
  overflow-y: auto;
  overflow-x: hidden;
  display: grid;
  align-self: self-start;
  max-height: 100%;
  grid-template: min-content auto min-content / min-content auto min-content;
  padding-top: 24px;

  ${media.up("TABLET")`
    place-content: center;
    padding-top: 48px;
  `}

  ${media.up("LAPTOP")`
    place-self: center;
    justify-content: center;
    padding-top:0;
  `}
`;

export const TableCardsWrapper = styled.div<{
  isSideWrapper?: boolean;
  numOfCards?: number;
}>`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  width: ${({ isSideWrapper }) => (isSideWrapper ? "auto" : "100%")};

  &:last-child,
  &:first-child {
    grid-column: 1 / 4;
  }

  &:nth-child(2) {
    margin-right: 20px;
  }
  &:nth-child(4) {
    margin-left: 20px;
  }

  ${media.up("LAPTOP")`
    &:nth-child(2) {
      margin-right: 44px;
    }
    &:nth-child(4) {
      margin-left: 44px;
    }
  `}

  ${({ numOfCards }) =>
    numOfCards &&
    numOfCards > 10 &&
    css`
      & > *:first-child {
        margin-left: 0;
      }
      & > *:last-child {
        margin-right: 0;
      }
    `}

  @media ${({ theme }) => theme.mq.md} {
    flex-wrap: nowrap;

    ${({ isSideWrapper }) =>
      isSideWrapper &&
      css`
        flex-direction: column;
        justify-content: center;
        //height: 268px;
        width: auto;

        & > *:not(:first-child) {
          margin-left: 0;
          margin-top: 20px;
        }
      `}
  }
`;
export const CurrentUserCardContainer = styled.div`
  margin-top: 15px;
  grid-area: userCard;
`;
